module.exports = __webpack_public_path__ + "static/media/studio.a430ed31.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/studio.gif
// module id = 615
// module chunks = 0